import { PayPalButtons, usePayPalScriptReducer,	getScriptID, destroySDKScript, } from '@paypal/react-paypal-js';
import { useEffect } from 'react';

// Show state
function Checkout(props) {
	const [{ options }, dispatch] = usePayPalScriptReducer();

  useEffect(() => {
    destroySDKScript(getScriptID({
      'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
      currency: "USD",
      intent: "capture",
    }));
    dispatch({
      ...options,
      type: "setLoadingStatus",
      value: "initial",
    });
  }, [props.total]);
  const update = (data, actions, err) => {
    return actions.order.create({
      intent: "CAPTURE",
      purchase_units: [
        props.total,
      ],
    });
  }
  
  return (
    <div style={{ width: '100%' }}>
      <PayPalButtons
        fundingSource='paypal'
        createOrder= { update }
        onApprove={(data, actions) => {
          return actions.order.capture().then((details) => {
            props.clearCart();
          }); 
        }}
      />
    </div>
  );
}

export default Checkout;